import React, { Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import Header from '../Header/Header'
import Sidebar from '../Sidebar/Sidebar'
import layoutJSON from './layout.json'
import ICO from '../../pages/ICOManagement/ICO'
const Dashboard = React.lazy(() => import('../../pages/dashboard/Dashboard'))
const AppSetting = React.lazy(() => import('../../pages/AppSetting/AppSetting'))
const ContactUs = React.lazy(() => import('../../pages/Support/ContactUs'))
const SecurityManagement = React.lazy(() =>
  import('../../pages/SecurityManagement/SecurityManagement')
)
const Faqs = React.lazy(() => import('../../pages/Faqs/Faqs'))
const Contact = React.lazy(() => import('../../pages/Contact/Contact'))
const ComingSoon = React.lazy(() => import('../../pages/ComingSoon/ComingSoon'))
const ExpertOpinion = React.lazy(() =>
  import('../../pages/ExpertOpinion/ExpertOpinion')
)
const CoinFeatures = React.lazy(() =>
  import('../../pages/CoinFeatures/CoinFeatures')
)
const RoadMap = React.lazy(() => import('../../pages/RoadMap/RoadMap'))
const UserManagement = React.lazy(() =>
  import('../../pages/User Mangment/UserManagement')
)
const LoginHistory = React.lazy(() =>
  import('../../pages/Admin Login History/LoginHistory')
)

const TermPolicy =React.lazy(() => import('../../pages/Term Policy/Termpolicy'))

const Investment = React.lazy(() => import('../../pages/Investment/Investment'))
function Layout () {
  const [navbarOpen, setNavbarOpen] = React.useState(true)
  const handleNavbar = () => setNavbarOpen(!navbarOpen)

  return (
    <div className='overflow-hidden bg-[#10121F] min-h-screen flex'>
      <div
        className={`h-full ${
          navbarOpen ? 'w-64' : 'w-0'
        } absolute md:relative transition ease-in-out`}
      >
        <Sidebar
          SidebarJSON={layoutJSON.sidebarJSON}
          navbarOpen={navbarOpen}
          setNavbarOpen={setNavbarOpen}
        />
      </div>
      <div
        className={`flex flex-col ${
          navbarOpen ? 'flex-1' : 'w-full'
        } overflow-hidden`}
      >
        <Header
          HeaderJSON={layoutJSON.headerJSON}
          handleNavbar={handleNavbar}
        />
        <Suspense
          fallback={
            <div className='flex justify-center items-center h-screen text-xl'>
              Loading...
            </div>
          }
        >
          <Routes>
            <Route path='/dashboard' element={<Dashboard />} />
            <Route path='/app-setting' element={<AppSetting />} />
            <Route path='/support' element={<ContactUs />} />
            <Route
              path='/change-password'
              element={<SecurityManagement />}
            />
            <Route path='/contact' element={<Contact />} />
            <Route path='/faq-management' element={<Faqs />} />
            <Route path='/coming-soon' element={<ComingSoon />} />
            <Route path='/expert-opinion' element={<ExpertOpinion />} />
            <Route path='/coin-features' element={<CoinFeatures />} />
            <Route path='/user-management' element={<UserManagement />} />
            <Route path='/investment-history' element={<Investment />} />
            <Route path='/term-policy' element={<TermPolicy />} />
            <Route path='/login-history' element={<LoginHistory />} />
            <Route path='/roadmap' element={<RoadMap />} />
            <Route path='/ico-management' element={<ICO />} />
          </Routes>
        </Suspense>
      </div>
    </div>
  )
}

export default Layout
